import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MaintFolderService } from "@viewer/toc-items/maint-folder-module/services/maint-folder.service";
import { TocItemTree } from "@orion2/models/tocitem.models";
import { MessageService } from "@orion2/message-service/message.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIcon } from "@angular/material/icon";
import { FormsModule } from "@angular/forms";
import { MatSliderModule } from "@angular/material/slider";
import { MatButton } from "@angular/material/button";

@Component({
  standalone: true,
  imports: [
    MatIcon,
    FormsModule,
    MatSliderModule,
    MatButton,
    MatToolbar,
    TranslateModule,
    MatDialogModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: "o-maint-folder-modal",
  templateUrl: "./maint-folder-modal.component.html",
  styleUrls: ["./maint-folder-modal.component.scss"]
})
export class MaintFolderModalComponent {
  public maxDepth = 3;
  public maxDM = 10;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private dialog: MatDialogRef<MaintFolderModalComponent>,
    private maintFolderService: MaintFolderService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  close(response = false): void {
    this.dialog.close(response);
  }

  submit(): void {
    let tree: TocItemTree;
    let depth = this.maxDepth;

    do {
      tree = this.maintFolderService.generateTree(this.data, depth, this.maxDM);
      depth--;
    } while (this.maintFolderService.nbrOfNodes > this.maxDM && depth >= 0);
    depth++;

    this.maintFolderService
      .save(tree)
      .then(() => {
        if (this.maxDepth !== depth) {
          this.messageService.warning(
            this.translate.instant("maint.folder.creation.warning", {
              depth,
              nbrDMs: this.maintFolderService.nbrOfNodes
            }),
            undefined,
            5000
          );
        } else {
          this.messageService.success(
            this.translate.instant("maint.folder.creation.success", {
              nbrDMs: this.maintFolderService.nbrOfNodes
            })
          );
        }
      })
      .catch(() => {
        this.messageService.error(
          this.translate.instant("maint.folder.creation.error"),
          undefined,
          5000
        );
      })
      .finally(() => {
        this.dialog.close();
      });
  }
}
